@if (formGroup) {
  <form [formGroup]="formGroup" class="grid grid-cols-1 gap-4">
    <div class="flex gap-3 items-center">
      <em-select
        formControlName="column"
        [subscriptSizing]="'dynamic'"
        [label]="'SHARED_LABEL_CHANEGD_PRICE' | translate"
        class="w-full"
      >
        <em-option [value]="null"> </em-option>
        @for (price of pricesList; track $index) {
          <em-option [value]="price.value">
            {{ price.label | translate }}
          </em-option>
        }
        <em-error>{{ 'SHARED_REQUIRED_FIELD' | translate }}</em-error>
      </em-select>
      <em-more-info
        class="ml-auto"
        [maxWidth]="500"
        [description]="'CAMPAIGN_PERFORMANCE_FILTER_PRICE_CHANGES_DESCRIPTION'"
      ></em-more-info>
    </div>

    <div class="grid grid-cols-2 gap-4">
      <!-- Operator -->

      <em-select
        formControlName="operator"
        [subscriptSizing]="'dynamic'"
        [label]="'SHARED_LABEL_NUMBER_OF_CHANGES' | translate"
      >
        <em-option [value]="null"> </em-option>
        @for (operator of operators; track $index) {
          <em-option [value]="operator.name">
            {{
              'G_FILTER_' + operator.name.toUpperCase() + '_VALUE' | translate
            }}
          </em-option>
        }
        <em-error>{{ 'SHARED_REQUIRED_FIELD' | translate }}</em-error>
      </em-select>

      <em-input
        formControlName="value"
        [subscriptSizing]="'dynamic'"
        [step]="1"
        type="number"
      >
        <em-error>{{
          'SHARED_RANGE_FIELD_ERROR' | translate: {min: 1, max: 100}
        }}</em-error>
      </em-input>
    </div>

    <mat-slide-toggle
      formControlName="includeWithInsufficientData"
      color="primary"
    >
      <span>{{
        'G_FILTER_PRICE_CHANGES_INCLUDE_WITH_INSUFFICIENT_DATA_INPUT_PLACEHOLDER'
          | translate
      }}</span>
    </mat-slide-toggle>

    <em-select
      formControlName="source"
      [subscriptSizing]="'dynamic'"
      [label]="'SHARED_LABEL_SOURCE' | translate"
    >
      <em-option [value]="null"> </em-option>
      @for (source of sources; track $index) {
        <em-option [value]="source.id">
          {{ source.name }}
        </em-option>
      }
    </em-select>

    <mat-slide-toggle
      #toggler
      color="primary"
      formControlName="toleranceEnabled"
    >
      <span translate
        >G_FILTER_PRICE_CHANGES_TOLERANCE_ENABLED_INPUT_PLACEHOLDER</span
      >
    </mat-slide-toggle>

    @if (formGroup.get('toleranceEnabled')?.value) {
      <em-input
        formControlName="tolerancePercent"
        [subscriptSizing]="'dynamic'"
        [min]="0"
        [max]="100"
        [step]="1"
        type="number"
        class="w-72"
      >
        <ng-container emSuffix><mat-icon>percent</mat-icon></ng-container>
        <em-error>{{
          'SHARED_RANGE_FIELD_ERROR' | translate: {min: 1, max: 100}
        }}</em-error>
      </em-input>
    }
  </form>
}
